import { getCollectionInventoryByHandle } from '@api/inventory'
import { getProductsWithUpdatedVariants } from '@helpers/filters/updateVariants'
import trackError from '@helpers/trackError'
import { useEffect, useState } from 'react'
import { Collection } from 'types/collection'

function getCollectionsWithFilteredVariants(
  collections: Collection[] = [],
  variants = []
) {
  return collections.map(collection => {
    const items = getProductsWithUpdatedVariants(collection.items, variants)
    return {
      ...collection,
      items
    }
  })
}

export function useFetchVariants(
  collectionHandle: string,
  collections: Collection[]
) {
  const [updatedCollections, setUpdatedCollection] = useState(collections)
  const [variantExist, setVariantExist] = useState(false)

  useEffect(() => {
    const fetchVariants = async () => {
      try {
        const variants = await getCollectionInventoryByHandle(collectionHandle)
        const filteredCollection = getCollectionsWithFilteredVariants(
          collections,
          variants.collectionInventory.products
        )
        setUpdatedCollection(filteredCollection)
        setVariantExist(true)
      } catch (e) {
        const variantsError = new Error(
          'Collection Product fetchVariants failed'
        )
        const error = e instanceof Error ? e : variantsError
        trackError(variantsError, { error })
      }
    }

    if (collectionHandle) fetchVariants()
  }, [collectionHandle])

  return { updatedCollections, variantExist }
}
